import { render } from "./simpleMap.vue?vue&type=template&id=4155aff4"
import script from "./simpleMap.vue?vue&type=script&lang=js"
export * from "./simpleMap.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__